export default "__VITE_ASSET__DezqKPda__"